import {HeadCell} from "interfaces";

export const headCells: readonly HeadCell[] = [
  {
    id: "name",
    disablePadding: true,
    label: "Nombre",
  },
  {
    id: "price",
    disablePadding: false,
    label: "Precio",
  },
  {
    id: "units",
    disablePadding: false,
    label: "Unidades",
  },
  {
    id: "archives",
    disablePadding: false,
    label: "Archivos",
  },
  {
    id: "actions",
    disablePadding: false,
    label: "",
  },
];
